import React from "react";
import SimpleMap from "./map.js";

import "../../scss/Footer.scss";
import Oeffnungszeiten from "./oeffnungszeiten.js";

const Footer = () => {
  return (
    <footer className="App__footer">
      <section className="App__footer--first">
        <SimpleMap />
        <section className="App__footer--contact App__footer--first--overlay">
          <div>
            <h3>Kontakt</h3>
            <p>Restaurant El Greco</p>
            <p>
              Berliner Str. 49
              <br />
              38165 Lehre
            </p>
            <p>
              <a href="tel:+495308961366">05308 / 96 13 66</a>
            </p>
          </div>
          <hr />
          <Oeffnungszeiten></Oeffnungszeiten>
        </section>
      </section>
      <section class="App__footer--last">
        <p>
          <a
            href="https://www.facebook.com/ElGrecoLehre/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Facebook
          </a>
          |<a href="/impressum">Impressum</a>
        </p>
      </section>
    </footer>
  );
};

export default Footer;
